<template>
  <div class="h-full p-4">
    <!-- <pre>
      history  {{history}}
    </pre> -->
    <!-- <pre>
        {{history}}
      </pre> 
      row_selected <pre>
        {{ row_selected }}
      </pre> -->
    <!-- <pre>
        row_selected   {{ row_selected }}
      </pre
    > -->
    <div class="border-2 border-gray-700 p-2">
      <table class="w-full border border-gray-300">
        <tr>
          <td
            colspan="2"
            style="background: #e9967a"
            class="font-bold text-center"
          >
            {{ row_selected.classification.classification }}
          </td>
        </tr>
        <tr>
          <td>
            Date
          </td>
          <td>
            {{ moment(row_selected.reg_date) }}
          </td>
        </tr>
        <tr>
          <td>Full Name</td>
          <td colspan="2">
            {{ row_selected.buyer_name }}
          </td>
        </tr>
        <tr>
          <td>Project</td>
          <td colspan="2">
            {{ project }}
          </td>
        </tr>
        <tr>
          <td>Property Details</td>
          <td colspan="2">
            {{ property }}
          </td>
        </tr>
        <tr>
          <td class="w-1/4">Subject</td>
          <td colspan="2">
            {{ row_selected.subject }}
          </td>
        </tr>
        <tr>
          <td class="w-1/4">Request</td>
          <td colspan="2">
            {{ row_selected.classification.classification }}
          </td>
        </tr>
        <!-- <tr>
          <td>Progress</td>
          <td colspan="2">
            {{ row_selected.remarks }}
          </td>
        </tr> -->
        <tr>
          <td>Status</td>
          <td colspan="2">
            {{ row_selected.status }}
          </td>
        </tr>
        <tr>
          <td class="w-1/4">
            Ticket Number:
          </td>
          <td class="w-1/4">
            {{ row_selected.moldex_ticket_number }}
          </td>
        </tr>
      </table>
    </div>
    <div class="border-2 border-gray-700 p-2">
      <div>Notifications</div>
      <div v-for="(item, i) in history.data" :key="i" class="flex">
        <ul class="flex list-disc">
          <li>
            <div class="flex py-2 items-center">
              <div class="pr-2">{{ moment(item.reg_date) }}</div>
              <v-btn color="secondary" small @click="open_email_content(item)">
                View Response
              </v-btn>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <v-dialog
      v-model="dialog_email_content"
      persistent
      :overlay="false"
      transition="dialog-transition"
    >
      <EmailContent
        :email_content="email_content"
        @close_dialog="close_dialog"
      />
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import EmailContent from "./EmailContent.vue";
import SecureStorage from "../../../utils/secureStorage";
export default {
  data() {
    return {
      email_content: "",
      dialog_email_content: false,
      emails: [],
      table: [],
      property: null,
      project: null,
    };
  },
  components: {
    EmailContent,
  },
  watch: {
    row_selected: {
      immediate: true,
      handler(row_selected) {
        // this.getEmails(row_selected.ticket_id);
        this.populateDataTable(
          row_selected.ticket_id,
          SecureStorage.getItem("auth").userId
        );
        this.populateDetails();
        // this.getHistoryEmailNotifications(row_selected.ticket_id);
      },
    },
  },
  props: ["user_id", "row_selected", "history"],
  methods: {
    // getHistoryEmailNotifications(ticket_id){

    // },
    populateDetails() {
      this.project = SecureStorage.getItem("auth").property;
      this.property =
        SecureStorage.getItem("auth").block +
        " " +
        SecureStorage.getItem("auth").lot +
        " " +
        SecureStorage.getItem("auth").phase;
    },
    close_dialog() {
      this.dialog_email_content = false;
    },
    open_email_content(content) {
      this.dialog_email_content = true;
      this.email_content = content;
    },

    moment(date) {
      return moment(date).format("LLL");
    },
    populateDataTable(ticket_id, userid) {
      let data = {
        user_id: userid,
        ticket_id: ticket_id,
      };
      axios.post("/customer/progress", data).then((res) => {
        this.table = res.data;
      });
    },
  },
};
</script>

<style scoped>
td {
  border: 1px solid #505050;
  padding: 4px;
}
.thtd {
  border: 1px solid #505050;
  padding: 4px;
}
.row:hover {
  background: orange;
}
</style>
